const $body = $('body'),
    $header = $('header.masthead');

function toggle_menu () {
    if ($body.hasClass('show-menu')) {
        hide_menu();
    } else {
        show_menu();
    }
}

function show_menu () {
    if (!$body.hasClass('show-menu')) {
        if (viewport().width < 992 && $(window).scrollTop() > 0) {
            // if on mobile and scrolled down, go back to top before showing menu to prevent unfriendly scroll 'jump'
            $('html, body').animate({
                scrollTop: 0
            }, 1000, 'easeInOutCubic', function () {
                $('.menu-icon').addClass('menu-icon--active');
                $('.hamburger').addClass('hamburger--active');
                $body.addClass('show-menu');
                $body.trigger('show-menu');
            });
        } else {
            // if not scrolled, show menu immediately
            $('.menu-icon').addClass('menu-icon--active');
            $('.hamburger').addClass('hamburger--active');
            $body.addClass('show-menu');
            $body.trigger('show-menu');
        }
    }
}

function hide_menu () {
    if ($body.hasClass('show-menu')) {
        $('.menu-icon').removeClass('menu-icon--active');
        $('.hamburger').removeClass('hamburger--active');
        $body.trigger('hide-menu');
    }
}

$('#toggle-menu, #toggle-menu-bottom').click(function (e) {
    e.preventDefault();
    toggle_menu();
});

$('#close-menu').click(function (e) {
    e.preventDefault();
    hide_menu();
});


// if escape key is pressed, close menu
$(document).keyup(function (e) {
    if (e.keyCode == 27) {
        hide_menu();
    }
});


$body.on('show-search', hide_menu);


let timeline = new TimelineLite({paused:true});

if (viewport().width > 991) {
    timeline
        .set('.overlay-menu', {
            overflow: 'hidden',
        })
        .from('.overlay-menu', 1, {
            height: 0,
            ease: Power3.easeInOut
        })
        .from('.overlay-menu__left', .75, {
            autoAlpha: 0,
            y: 50,
            ease: Power2.easeInOut
        }, "-=.5")
        .from('.overlay-menu__center', .75, {
            autoAlpha: 0,
            y: 50,
            ease: Power2.easeInOut
        }, "-=.35")
        .from('.overlay-menu__right', .75, {
            autoAlpha: 0,
            y: 50,
            ease: Power2.easeInOut
        }, "-=.35")
        .set('.overlay-menu', {
            overflow: 'auto',
        });
} else {
    timeline
        .set('.overlay-menu', {
            overflow: 'hidden',
        })
        .from('.overlay-menu', 1, {
            height: 0,
            ease: Power3.easeInOut
        })
        .from('.overlay-menu__inner', .75, {
            autoAlpha: 0,
            y: 50,
            ease: Power2.easeInOut
        }, "-=.5")
        .set('.overlay-menu', {
            overflow: 'auto',
        });
}

timeline.eventCallback('onReverseComplete', function() {
    $body.removeClass('show-menu');
});

$body.on('show-menu', function () {
    timeline.restart().timeScale(1);
});

$body.on('hide-menu', function () {
    timeline.reverse().timeScale(2); // close menu with faster reversed animation
});


// set current menu-item class
$('.overlay-menu .menu__item > a, .sticky-nav-bar .menu__item > a').each(function () {
    let $match = $(this).attr('href'),
        $url = window.location.href;

    // strip trailing slash in both strings
    $match = $match.replace(/\/$/, '');
    $url = $url.replace(/\/$/, '');

    if ($match === $url) {
        $(this).closest('.menu__item').addClass('menu__item--current');
    }
});


// toggle child-nav sub-menus
$('.overlay-menu__child .menu__sub-menu-toggle').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    let $toggle = $(this),
        $item = $(this).closest('.menu__item'),
        $submenu = $item.find('.menu__sub-menu');

    $toggle.toggleClass('menu__sub-menu-toggle--active');
    $submenu.stop().slideToggle(150);
});